export const useUser = () => {
  const { session } = useAuth()
  const ns = useRuntimeConfig().public.auth0MetadataNamespace || 'keyreply'

  const roles = computed(() => {
    const meta: any = session.value?.user?.app_metadata
    return (meta?.[ns]?.roles as string[] | undefined) ?? (meta?.roles as string[] | undefined) ?? []
  })

  const isAdmin = computed(() => {
    return roles.value.includes('admin')
  })

  const isCreator = computed(() => {
    return roles.value.includes('creator')
  })

  const isKeyreplyUser = computed(() => {
    const email = (user.value as any)?.email as string | undefined
    return !!email && email.endsWith('@keyreply.com') && !email.includes('singhealth')
  })

  const getAssistants = computed(() => {
    return session.value?.user?.app_metadata?.assistants || []
  })

  const hasPermission = (permission: string) => {
    const meta: any = session.value?.user?.app_metadata
    const perms: string[] = (meta?.[ns]?.permissions as string[] | undefined) ?? (meta?.permissions as string[] | undefined) ?? []
    return perms.includes(permission)
  }

  const user = computed(() => ({
    ...session.value?.user,
    notifPhone: session.value?.user?.app_metadata?.notifPhone || null
  }))

  const isOrgMember = function (org: string) {
    return session.value?.user?.app_metadata?.organization === org
  }

  const isPermissionSuperAdmin = computed(() => {
    return user.value?.app_metadata?.permissions?.includes('superadmin')
  })

  return {
    user,
    roles,
    isAdmin,
    getAssistants,
    hasPermission,
    isPermissionSuperAdmin,
    isOrgMember,
    isCreator,
    isKeyreplyUser
  }
}
